import React from 'react';
import { CssBaseline, Stack, ThemeProvider, createTheme } from '@mui/material';
import SignInCard from '../components/SignInSide';

const theme = createTheme();

export default function LoginPage() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Stack
        direction="column"
        component="main"
        sx={{
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #ece9e6 0%, #ffffff 100%)',
          alignItems: 'center',
        }}
      >
        <SignInCard />
      </Stack>
    </ThemeProvider>
  );
}
